module.exports = __webpack_public_path__ + "img/gold30.903bb6ae.png";